import { Add, EmojiEvents, Link, Remove } from "@mui/icons-material";
import { Avatar, Divider, Grid, IconButton, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import moment from "moment";
import React, { useEffect, useState } from "react";
import "moment/locale/ca";
import PageAdmin from "../../components/PageAdmin";
import Loading from "../../components/Loading";
import { Finals, Inscrits } from "../../db/firebase";
import { useCountdown } from "../../components/countdown";
import { ThemeProvider } from "@mui/styles";
import InscritsColumns from "../../components/tables/InscritsColumns";
import getMuiTheme from "../../components/tables/getMuiTheme";
import MUIDataTable from "mui-datatables";
import TableOptions from "../../components/tables/TableOptions";

function HomeAdmin() {
	const [loadingI, errorI, inscrits, getInscrits, addInscrit, removeInscrit] = Inscrits();
	const [loadingF, errorF, finals, getFinals, addFinals, removeFinals, removeInscrits] = Finals();
	const classes = useStyles();
	const [days, hours, minutes, seconds] = useCountdown(moment().format("YYYY-MM-DD HH:mm:ss"));
	const columns = InscritsColumns();
	const options = TableOptions("inscrits");
	const [inscritsF, setInscritsF] = useState([]);

	useEffect(() => {
		getInscrits();
		getFinals();
	}, []);

	useEffect(() => {
		const x =
			finals?.length > 0
				? finals
						?.map((val) => val?.llista ?? [])
						.reduce((pre, cur) => pre.concat(cur))
						.map((e) => e)
				: [];
		const concatenat = inscrits?.map((ins) => {
			return { ...ins, comparsa: x?.find((f) => f.dni_nen === ins.dni_nen)?.comparsa };
		});
		setInscritsF(concatenat);
	}, [finals]);

	return (
		<PageAdmin title="Inscrits">
			<Loading loading={loadingI}>
				<Box className={classes.bloc} mb={3}>
					<ThemeProvider theme={getMuiTheme()}>
						<MUIDataTable data={inscritsF} columns={columns} options={options} />
					</ThemeProvider>
				</Box>
			</Loading>
		</PageAdmin>
	);
}

export default HomeAdmin;

const useStyles = makeStyles((theme) => ({
	bloc: {
		padding: 40,
	},
}));
